import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Platform } from 'react-native';
import { pure } from '@dbk-legacy/ui-react-utils';

import Text from '../../../../../../../src/components/common/text';
import Link from '../../../../../../../src/components/common/link';
import NavigationArrow from '../../../../../../../src/components/common/navigation-arrow';

import KeyValueListView from '../../../../components/common/key-value-list-view';
import AbbreviatedGroup from '../../../../../../../src/components/common/abbreviated-group';
import TransactionDetailsDescription from './transaction-details-description';
import styles from './transaction-details.styles';
// import { setCustomSourceTransformer } from 'react-native/Libraries/Image/resolveAssetSource';
import BlurModal from '../../../../../../../src/components/common/blur-modal';
//import AdvicesButton from '../advice-list/advices-button';
import TransactionSecurityAdvice from '../transaction-security-advice/transaction-security-advice';

class TransactionDetails extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      doneVisible: true,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  componentWillMount() {
    const {
      row = {},
      headerGroup = [],
      detailsGroups = [],
      labels = {},
      abbreviationRules = {},
      messages
    } = this.props;
  }

  toggleModal() {
    const { changePage, tradeNumber, valueDate, tradeDate, row } = this.props;
    const adviceItem = {
      tradeNo: row.tradeNumber,
    };

    this.props.transact.getAdvices({
      adviceItem
    });
  }

  render() {
    const {
      modal,
      doneVisible
    } = this.state;

    const { transact, messages } = this.props;

    if (transact.isEmpty) {
      transact.setIsEmpty(false);
      alert(messages['app.position.transDetails']);
    }

    return (
      <View style={styles.root} testID="expandable-item">
        <View testID="details">
          <AbbreviatedGroup
            data={this.props.row}
            dataDefinitions={this.props.headerGroup}
            abbreviationRules={this.props.abbreviationRules}
            renderTopSeparator={false}
            messages={messages}
            renderBottomSeparator
          />
          <KeyValueListView
            detailsGroups={this.props.detailsGroups}
            row={this.props.row}
            abbreviationRules={this.props.abbreviationRules}
            renderFirstSeparator={false}
            messages={messages}
          />
        </View>
        <TransactionDetailsDescription description={this.props.row.type} />
        <TransactionSecurityAdvice transaction={this.props.row} />
      </View>
    );
  }
}
// <div style={{'cursor': 'pointer'}} onClick={this.toggleModal}>
//   <Text> {this.props.labels.seeAdvice}</Text>
//   <span className="arrowClass"><NavigationArrow/></span>
// </div>
TransactionDetails.propTypes = {
  row: PropTypes.shape({
    type: PropTypes.string,
    tradeNumber: PropTypes.number,
    valueDate: PropTypes.string,
    purchasePrice: PropTypes.number,
    purchasePriceUnit: PropTypes.string,
    netAmount: PropTypes.number,
  }),
  detailsGroups: KeyValueListView.propTypes.detailsGroups,
  labels: PropTypes.shape({
    seeAdvice: PropTypes.string,
  }),
  headerGroup: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  })),
  abbreviationRules: PropTypes.object,
  modal: PropTypes.bool,
  doneVisible: PropTypes.bool,
};

export default TransactionDetails;
